import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader } from "@/components/common/Loader";
import { TicketStatusBadge } from "@/components/common/Badges";
import { TicketThread, ReplyBox } from "@/components/common/TicketThread";
import { api, errMsg, useFetch } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

export default function TicketDetail() {
  const { id } = useParams();
  const { data, loading, error, reload } = useFetch(`/tickets/${id}`);
  if (loading && !data) return <Loader />;
  if (error) return <p className="text-sm text-destructive">{error}</p>;
  const { ticket: t, messages } = data;

  const send = async (fd) => {
    try {
      await api.post(`/tickets/${id}/messages`, fd);
      await reload();
      return true;
    } catch (e) {
      toast.error(errMsg(e));
      return false;
    }
  };
  const reopen = async () => {
    try {
      await api.post(`/tickets/${id}/reopen`);
      toast.success("Ticket riaperto");
      reload();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div className="max-w-3xl">
      <Link to="/assistenza" className="btn-link" data-testid="back-to-tickets">← Le tue richieste</Link>
      <div className="mt-6 mb-10 animate-fade-up">
        <div className="flex items-center gap-3 flex-wrap">
          <span data-testid="ticket-code" className="text-xs tracking-[0.14em] text-warm-text">{t.code}</span>
          <TicketStatusBadge status={t.status} />
        </div>
        <h1 data-testid="ticket-subject" className="text-3xl sm:text-4xl font-light mt-3 leading-tight">{t.subject}</h1>
        <p className="text-xs text-warm-text mt-2">{t.category_name} · Aperto il {fmtDateTime(t.created_at)}</p>
      </div>
      <TicketThread messages={messages} viewer="center" />
      <div className="mt-10">
        {t.status === "chiuso" ? (
          <p data-testid="ticket-closed-note" className="lux-card p-5 text-sm text-warm-text">Questa conversazione è chiusa. Se ti serve altro, <Link to="/assistenza/nuovo" className="btn-link">apri una nuova richiesta</Link>.</p>
        ) : (
          <>
            {t.status === "risolto" && t.can_reopen && (
              <div data-testid="ticket-resolved-note" className="lux-card p-5 mb-4 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <p className="text-sm text-warm-text">Abbiamo segnato questa richiesta come risolta. Se serve ancora qualcosa puoi riaprirla entro 7 giorni.</p>
                <button data-testid="ticket-reopen-btn" onClick={reopen} className="btn-ghost shrink-0">Riapri</button>
              </div>
            )}
            <ReplyBox onSend={send} />
          </>
        )}
      </div>
    </div>
  );
}
